import { createEnvelopeSource } from './create-envelope-source';

/**
 * Email opt-ins source over the standardized envelope (`GET /analytics/opt-ins`).
 * `emailOptIns` is a STANDING total of email-opted-in users, province/BU-aware.
 * It is period-INDEPENDENT (no opt-in timestamp recorded), so it does not change
 * with the dashboard date range; the card description says so. `number` form
 * (single full-app value, not a split).
 *
 * The RPP standing counts are their own source (`opt-ins-rpp`): a different
 * table, a different population, and two metrics against this one. They are not
 * a slice of `emailOptIns` and must not be read as one.
 */
export const optInsSource = createEnvelopeSource({
    label: 'Opt-ins',
    endpoint: 'analytics/opt-ins',
    metrics: [{ id: 'emailOptIns', label: 'Email opt-ins', type: 'scalar' }],
    forms: ['number'],
    regionGrain: 'province',
});
